// import reframe from "../../node_modules/reframe.js";
// import "reframe.js";
// import "../../node_modules/reframe.js";
// reframe("iframe"); // Wrap all iFrames in the page


jQuery(document).ready(function ($) {
    $("body").on("click", ".question", function () {
        $(this).parent().toggleClass("show-answer");
    });

    if (window.location.hash.length > 0) {
        $('html,body').animate({scrollTop:$(location.hash).offset().top - 150 }, 500);
        $(location.hash).parent().addClass("show-answer");
    }

    jQuery('a[href^="#"]').on('click',function(e) {
        e.preventDefault();
        var target = this.hash;
        var $target = $(target);

        $('html,body').animate({scrollTop:$target.offset().top - 100}, 500);

    });

});

jQuery(document).ready(function ($) {
    $("body").on("click", ".button-add-guest", function (e) {
        e.preventDefault();
        $(this).parent().find("input").val(parseInt($(this).parent().find("input").val()) + 1);
    });

    $("body").on("click", ".button-remove-guest", function (e) {
        e.preventDefault();
        $(this).parent().find("input").val(parseInt($(this).parent().find("input").val()) - 1);
    });



    $("body").on("click", ".button-add-bedrooms", function (e) {
        e.preventDefault();
        $(this).parent().find("input").val(parseInt($(this).parent().find("input").val()) + 1);
    });

    $("body").on("click", ".button-remove-bedrooms", function (e) {
        e.preventDefault();
        $(this).parent().find("input").val(parseInt($(this).parent().find("input").val()) - 1);
    });


    var dateToday = new Date();
    $(".bookingselect__datepicker.till").datepicker({
            hideIfNoPrevNext: true,
            dateFormat: "dd.mm.yy",
            minDate: dateToday,
            numberOfMonths: 1,
            prevText: '←', prevStatus: '',
            nextText: '→', nextStatus: '',
            currentText: 'heute', currentStatus: '',
            todayText: 'heute', todayStatus: '',
            clearText: '-', clearStatus: '',
            closeText: 'schließen', closeStatus: '',
            monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
            monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
            dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
            dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
            dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
            firstDay: 1,
            beforeShow: function (input, inst) {

                setTimeout(function(){
                    $('#ui-datepicker-div').addClass("block-stoerer__calendar");
                    $('.ui-datepicker').css('z-index', 99999999999999);
                }, 0);
            }
        }
    );

    $(".bookingselect__datepicker.from").datepicker({
        onClose: function (dateText) {
            $(this).datepicker("widget").removeClass("grid-box-bookingselect__datepicker--wrap");
            var dateSplit = dateText.split(".");
            var newDate = new Date(parseInt(dateSplit[2]), parseInt(dateSplit[1]) - 1, parseInt(dateSplit[0]) + 1);
            $('.till').datepicker('option', 'minDate', newDate);

        },

        hideIfNoPrevNext: true,
        dateFormat: "dd.mm.yy",
        minDate: dateToday,
        numberOfMonths: 1,
        prevText: '←', prevStatus: '',
        nextText: '→', nextStatus: '',
        currentText: 'heute', currentStatus: '',
        todayText: 'heute', todayStatus: '',
        clearText: '-', clearStatus: '',
        closeText: 'schließen', closeStatus: '',
        monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
        dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
        dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        firstDay: 1,
        beforeShow: function (input, inst) {
            setTimeout(function(){
                $('#ui-datepicker-div').addClass("block-stoerer__calendar");
                $('.ui-datepicker').css('z-index', 99999999999999);
            }, 0);
        }
    });

});
